"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includes = void 0;
const is_array_1 = require("./is-array");
const is_object_1 = require("./is-object");
const is_string_1 = require("./is-string");
exports.includes = (iterable, value) => {
    if (is_array_1.isArray(iterable)) {
        return iterable.includes(value);
    }
    if (is_string_1.isString(iterable)) {
        return iterable.includes(value);
    }
    if (is_object_1.isObject(iterable)) {
        return Object.values(iterable).includes(value);
    }
    return false;
};
//# sourceMappingURL=includes.js.map